import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';
import { businessResolver } from './common/resolvers/business.resolver';

export const BUSINESS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./business/business.component').then((m) => m.BusinessComponent),
    canActivate: [permissionGuard('business.get')],
    resolve: { business: businessResolver },
  },
] as const;
